<!-- WaitlistForm.vue -->
<template>
  <div class="waitlist-overlay">
    <div class="waitlist-form">
      <div class="heading-row">
        <div class="nav-title">
          <img
            src="../../assets/bloom-icon-128px.png"
            class="bloom-icon"
            height="32px"
          />
          <h2>Bloom</h2>
          <div class="bloom-live" @click="navigateToDemo"> Take a look </div>
        </div>
        <p>Decode discrete, unstructured text at scale.</p>
      </div>
      <form @submit.prevent="submitForm" 
        :class="{ 'hide': submissionSuccess }" 
        class="form-container">
        <div class="form-group">
          <input type="text" id="name" placeholder="Full Name" v-model="name" required>
        </div>
        <div class="form-group">
          <input type="email" id="email" placeholder="Work Email" v-model="email" required>
        </div>
        <div class="form-group">
          <select v-model="feedbackType" required :class="{ 'default-option': feedbackType === '' }">
            <option value="" disabled selected>Select feedback type</option>
            <option value="app-reviews">App reviews</option>
            <option value="survey">Surveys</option>
            <option value="employee-performance">Employee performance</option>
            <option value="support-cases">Support cases</option>
            <option value="personal-feedback">Personal feedback</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div class="button-row">
          <button
            v-if="submissionState('button')"
            type="submit" 
            tabIndex="0" 
            @mousedown.prevent="preventMouseDown">
            Join the waitlist
          </button>
          <rtx-spinner class="rtx-element" v-if="submissionState('spinner')"></rtx-spinner>
        </div>
      </form>
      <div class="response-row"> 
        <div v-if="submissionState('response')"> {{ response }} </div>
      </div>
      <div class="success-icon-refpoint" :class="{ 'hide': !submissionSuccess }">
        <transition name="slide-fade">
          <img v-if="submissionSuccess" class="success-icon" src="../../assets/circled_checkmark.svg"></img>
        </transition>
      </div>
      <div class="footer-row"> 
        <a tabindex="0" href="/privacy">PRIVACY</a> | <a tabindex="0" href="/legal">LEGAL</a>
      </div>
    </div>
  </div>
</template>

<script>
import { waitlist } from '../../backend/site.js';

export default {
  data() {
    return {
      name: '',
      email: '',
      feedbackType: '',
      submitted: false,
      submissionSuccess: false,
      response: '',
    };
  },
  methods: {
    submitForm() {
      let formData = {
        name: this.name,
        email: this.email,
        feedbackType: this.feedbackType,
      }
      this.submitted = true;
      this.response = '';
      waitlist(formData)
        .then(result => {
          let data = result.data;
          if (data.status === 'success') {
            this.submissionSuccess = true;
            this.response = data.message;
          } else {
            this.submitted = false;
            this.response = data.message;
          }
        })
        .catch(error => {
           this.response = 'Failed to submit request.';
        });
    },

    preventMouseDown: (e) => {},

    submissionState(viewItem) {
      if (viewItem === 'button') {
        if (!(this.submitted || this.submissionSuccess)) return true;
      };
      if (viewItem === 'spinner') {
        if (this.submitted && !this.response) return true;
      };
      if (viewItem === 'response') {
        if (this.response) return true;
      };
    },

    navigateToDemo: (ev) => {
      window.location = 'https://app.withbloom.ai/demo';
    },
  },
};
</script>

<style scoped>
.waitlist-overlay {
  height: 100svh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.waitlist-form {
  position: relative;
  background-color: #FDFDFD;
  border: solid 1px #AAA;
  padding: 4rem;
  border-radius: 8px;
  width: 24rem;
  height: 472px;
  max-width: 90%;
  box-shadow: 1px 1px 5px 1px #EEE;
}

.nav-title {
  position: relative;
  grid-area: title;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0.1rem;
}

.bloom-live {
  position: absolute;
  top: -1rem;
  right: 1rem;
  background-color: #9A3356; /* Background color */
  border-radius: 4px; /* Rounded corners */
  padding: 0.18rem 0.8rem;
  color: white;
  font-weight: 500;
  font-size: 1rem;
  cursor: pointer;
}

.bloom-icon {
  position: absolute;
  height: 32px;
  cursor: pointer;
  margin-left: -6rem;
  margin-top: -0.4rem;
  padding-right: 1rem;
}

.form-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.form-group {
  width: 100%;
  text-align: center;
}

label {
  display: block;
  margin-bottom: 5px;
  max-width: 18rem;
  text-align: left;
  padding-left: 4rem;
}

input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0px 0px 2px #eee;
  max-width: 18rem;
  box-sizing: border-box;
}

input::placeholder {
  color: #888888; /* COLOR GREY OUT  */
}

/* Firefox placeholder style */
input::-moz-placeholder {
  color: #888888; /* COLOR GREY OUT  */
  opacity: 1;
}

/* Internet Explorer placeholder style */
input:-ms-input-placeholder {
  color: #888888; /* COLOR GREY OUT  */
}

/* Edge placeholder style */
input::-ms-input-placeholder {
  color: #888888; /* COLOR GREY OUT  */
}

.button-row {
  text-align: center;
  padding-top: 2rem;
}

.rtx-element {
  margin: auto;
}

.response-row {
  height: 2rem;
  margin-top: 1rem;
  text-align: center;
}

.heading-row {
  text-align: center;
  padding-bottom: 3rem;
  padding-top: 1rem;
}

button {
  background-color: #339A77;
  color: white;
  padding: 10px 20px;
  font-size: 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.footer-row {
  position: absolute;
  font-size: 0.88em;
  padding-top: 1em;
  color: #888888;
  bottom: 3rem;
  left: 50%;
  transform: translate(-50%);
}

a, u {
  text-decoration: none;
}

a {
  color: #888888;
}

a:hover {
  color: black;
}

select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0px 0px 2px #eee;
  max-width: 18rem;
}

select {
  background-color: white; /* Ensure the dropdown background is white */
  appearance: none; /* Remove default dropdown arrow for consistent styling */
  -webkit-appearance: none; /* Remove default dropdown arrow for Safari */
  -moz-appearance: none; /* Remove default dropdown arrow for Firefox */
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAvxJREFUeJzt3E2ID3Ecx/G3xw152oM8JQ+Rh5DDlptyECfl6OAiOXo4iYOLkps4Ui5byMFDe6AUkQMupEhKREJ5WLLlYZfDcFHs/uc/8/vOzP/9qs91Z+bzmXbb+c8uSJIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZKkTrMYOAf0Az/Nf/MROAssytV0BS0D3hNfbN3yDliSo+/K6SO+zLrmYo6+WzKq7AMAA8CEBMdpogFgUpkHGF3mF/9tMMExmupH2QdIcQP0JThGUzWiu9nAC+J/ntYtz4FZOfqupJX4K2Ar+QisyNV0hW0AvhNfbtXzDVifs+PK2058wVXPttzt1sQh4kuuag620Wut9BJfdtVyqq1Ga2Y8cJ340quSq8C4dgqto+nAI+LLj84DYGqbXdbWAuAN8SNE5RUwr+0Wa64H+EL8GKnzGVhTQH+NsJnsM4PoUVLlB7CpkOYaZBfxw6TKzoI6a5yjxI9Tdo4U1lYDjQbOEz9SWTlDmncwam0CcJv4sYrOTaCrwJ4abQbwlPjRispjoLvQhjrAUprxMulbYGHB3XSMdcBX4kfMmwFgbeGtdJitwBDxY7aaQWBLCX10pAPED9pq9pTSRAc7SfyoI82xkjroaGOBK8SPO1wukOZt6440BbhP/Mj/yh1gYmlXLwDmAi+JH/vvPCV7fqEEVgOfiB/9T96TPbdQQhupxmvmX8meVyjADmLHHyJ7TqFAh4m7AfYnuD4NYxRwmvTjn0hxcRqZLuAG6ca/TPZcQhXSTfaxa9nj3wMmJ7omtWgR2cevZY3/ApiT7GqUy1qyj2GLHr8fWJXwOtSGLRT7mvl3sj9vV43spbgbYHvic1dBjtP++IeSn7UKMwa4RP7xe9Ofsoo2EbhL6+NfI/szdjXATOAZIx//ITAt4kRVnuXAB4Yf/zUwP+YUVbYe/v8yyROyG0UNNgXYR/b6Vj/Zd4VbwG78n8aSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJCnQL74K1b7KD2ipAAAAAElFTkSuQmCC'); /* Custom arrow */
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: center;
  background-size: 1rem;
  padding-right: 2rem; /* Add padding to accommodate the custom arrow */
}

.default-option {
  color: #888888; /* COLOR GREY OUT  */
}

/* + Form submit / success */
.success-icon-refpoint {
   position: relative;
   top: -14rem;
   height: 0px;
   text-align: center;
}

.success-icon {
   width: 8rem;
}
/* - Form submit / success */

/* + Animation */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
{
  transform: translateX(10px);
  opacity: 0;
}
/* - Animation */

/* Responsive UI */
@media screen and (max-width: 740px) {
  .waitlist-form {
    padding: 4rem 2rem;
    border: none;
    box-shadow: none;
  }
}
/* Responsive UI */
</style>


// WEBPACK FOOTER //
// src/components/site/WaitlistForm.vue